export const TRACK_EVENT_DELAY_MS = 500
export default { TRACK_EVENT_DELAY_MS }
